import { Typography } from "@mui/material";
import React from "react";

export default function CoreTypographySubtitle2(props) {
  return (
    <Typography
      variant="subtitle2"
      style={{ fontWeight: 700, ...(props.style || {}) }}
      gutterBottom
    >
      {props.children}
    </Typography>
  );
}
